module.exports = __webpack_public_path__ + "static/img/b302.512377ee.png";